import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, ComponentFactoryResolver, ViewContainerRef, ComponentFactory, ComponentRef  } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { GlobalsService } from '../../services/globals.service';

@Component({
    selector: 'chart-base-widget',
    templateUrl: './chart-base-widget.component.html',
    styleUrls: ['./chart-base-widget.component.scss'],
    standalone: false
})
export class ChartBaseWidgetComponent {

    constructor(private svc_globals: GlobalsService, private svc_data: DashboardService) {

      }

}

